import React from 'react';
import { Link } from 'react-router-dom';

class BioPreview extends React.Component {

	render() {
		return (
			<div className="about--bio">
				<Link to={`/about/${this.props.details.url}/`}>
					<img src={`/img/about-portrait-${this.props.details.url}.jpg`} srcSet={`/img/about-portrait-${this.props.details.url}.jpg 1x, /img/about-portrait-${this.props.details.url}@2x.jpg 2x`} alt={`portrait of ${this.props.details.name}`}/>
				</Link>
				<span className="about--bio--name">{this.props.details.name}</span>
				<Link to={`/about/${this.props.details.url}/`}>View bio</Link>
			</div>
		)
	}
}

export default BioPreview;


/** WEBPACK FOOTER **
 ** ./src/components/BioPreview.js
 **/